import { create } from "zustand";
import type { EmailTemplate } from "@/types/email";

interface TemplatesState {
  templates: EmailTemplate[];
  currentTemplate: EmailTemplate | null;
  isLoading: boolean;
  error: string | null;

  // Actions
  fetchTemplates: (params?: {
    category?: string;
    isSystem?: boolean;
  }) => Promise<void>;
  getTemplate: (id: string) => Promise<void>;
  saveAsTemplate: (data: {
    name: string;
    description?: string;
    category?: string;
    emailDocumentId: string;
  }) => Promise<void>;
  reset: () => void;
}

export const useTemplatesStore = create<TemplatesState>((set, get) => ({
  templates: [],
  currentTemplate: null,
  isLoading: false,
  error: null,

  fetchTemplates: async (params?: {
    category?: string;
    isSystem?: boolean;
  }) => {
    set({ isLoading: true, error: null });
    try {
      // TODO: Templates feature is not yet implemented in the backend API
      // const result = await emailBuilderService.getTemplates(params);
      // set({ templates: result.items, isLoading: false });
      
      set({ 
        templates: [], 
        isLoading: false,
        error: "Templates feature is not yet available"
      });
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to fetch templates";
      set({ error: errorMessage, isLoading: false });
    }
  },

  getTemplate: async (id: string) => {
    set({ isLoading: true, error: null });
    try {
      // TODO: Templates feature is not yet implemented in the backend API
      // const template = await emailBuilderService.getTemplate(id);
      // set({ currentTemplate: template, isLoading: false });
      
      throw new Error("Templates feature is not yet available");
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to fetch template";
      set({ error: errorMessage, isLoading: false });
      throw error;
    }
  },

  saveAsTemplate: async (data) => {
    try {
      // TODO: Templates feature is not yet implemented in the backend API
      // const newTemplate = await emailBuilderService.saveAsTemplate(data);
      // set((state) => ({
      //   templates: [...state.templates, newTemplate],
      // }));
      
      throw new Error("Templates feature is not yet available");
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to save template";
      set({ error: errorMessage });
      throw error;
    }
  },

  reset: () => {
    set({
      templates: [],
      currentTemplate: null,
      isLoading: false,
      error: null,
    });
  },
}));
